import React from "react";
import { Image } from "semantic-ui-react";

const ProductDetailedImage = ({ product }) => {
  return <Image src={product.photoURL} style={{width:'92%'}} />;
};

export default ProductDetailedImage;
